import preq from '#app/lib/preq'
import type { ClientConfig } from '#server/controllers/config'
import { detectedEnv } from './lib/env_config'

const configEndpoint = '/api/config'

export const config: ClientConfig = await preq.get(configEndpoint)

// See scripts/build
interface BundleMeta {
  commit: string
  time: string
  bundle: string
}

export let bundleMeta: BundleMeta

try {
  bundleMeta = await preq.get('/public/bundle_meta.json')
} catch (err) {
  // Known case: if the client was not built
  // Using console directly to avoid circular dependencies
  if (detectedEnv === 'prod') console.error('bundle meta fetch error', err)
  // @ts-expect-error
  bundleMeta = {}
}
